<template>
    <div class="homeCard">
        <img :src="data.image" :alt="data.title"/>
        <div class="content">
            <h4 class="mb-2 mt-2">{{ data.title }}</h4>
            <p>{{ data.text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ["data"],
};
</script>

<style scoped>
.homeCard {
    display: flex;
    column-gap: 1.5rem;
    height: 18vh;

    img {
        height: 100%;
        object-fit: cover;
        flex: 1;
    }

    .content {
        flex: 2.5;
        padding: 1rem;
        background-color: var(--background-red);
    }
}

h4 {
    color: var(--main-red);
    font-family: Ultramagnetic, sans-serif;
    text-transform: uppercase;
    font-size: 1.3em;
}

p {
    white-space: pre-wrap;
    font-size: 1em;
}
</style>
